module.exports = __webpack_public_path__ + "static/media/09.e3805dd9.png";